<bit-simple-dialog hideIcon>
  <span bitDialogTitle>{{ "discardEdits" | i18n }}</span>
  <span bitDialogContent>{{ "discardEditsMessage" | i18n }}</span>
  <ng-container bitDialogFooter>
    <button type="button" bitButton buttonType="danger" (click)="discardEdits()">
      {{ "discardEdits" | i18n }}
    </button>
    <button type="button" bitButton buttonType="secondary" (click)="backToEditing()">
      {{ "backToEditing" | i18n }}
    </button>
  </ng-container>
</bit-simple-dialog>
